<template>
  <div class="home">
    <div class="images">
      <loop-play-images
        v-if="bannerImagesData != null"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="loopPlayImagesData.defaultClasses"
      />
    </div>
    <div class="popular_box"></div>
    <div style="margin-top: 540px"></div>
    <div class="movieList" v-for="(item, index) in templateData" :key="index">
      <ImageList
        :info="item"
        @moreClick="moreContentsClick"
        @movieClick="movieClick"
      />
    </div>
    <div class="advertisement" v-if="bottomBanner">
      <a :href="bottomBanner.link" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>
  </div>
</template>

<script>
import LoopPlayImages from '@/components/common/LoopPlayImages.vue'
import ImageList from '@/components/common/ImageList.vue'
import { getToken } from '@/utils/auth'

const iconMap = {
  '电影': { icon: 'movie_icon' },
  '电视剧': { icon: 'special' },
  '娱乐': { icon: 'recreation' },
  'RMHD': { icon: 'vip' },
  '精品': { icon: 'boutique' },
  '热播': { icon: 'host' }
}

export default {
  name: 'SpecialPage',
  components: {
    LoopPlayImages,
    ImageList
  },
  data() {
    return {
      bannerImagesData: null,
      bottomBanner: null,
      templateData: null,
      loopPlayImagesData: {
        defaultClasses: {
          outerRotateStage: 'loopImages',
          rotateStage: 'loopStage',
          innerShow: 'loopContainer',
          btn: 'btnOuter',
          circular: 'dots'
        }
      }
    }
  },
  computed: {
    pageTitle() {
      return this.$route.query.pageTitle || '电影'
    },
    detailPage() {
      return this.$route.query.detailPage || 'TVplayPage'
    }
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    getPageData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        params: { title: this.pageTitle },
        headers: { token: getToken() || '123456789' }
      }).then(res => {
        if (res.data.result) {
          const dataMap = res.data.result.dataMap || res.data.result
          this.bottomBanner = dataMap.bottomBanner ? dataMap.bottomBanner[0] : null
          if (dataMap.bannerList) {
            this.bannerImagesData = dataMap.bannerList.map(t => ({
              backgroundImage: t.image,
              imageLinkRouterName: t.link
            }))
          }
          if (dataMap.contentTemplateList) {
            this.loadTemplates(dataMap.contentTemplateList)
          }
        }
      })
    },
    getImgAttr(template) {
      const result = { icon: 'comedy', type: 'comedy', imgWidth: 192 }
      for (const key in iconMap) {
        if (template.name.indexOf(key) > -1) {
          result.icon = iconMap[key].icon
          break
        }
      }
      if (template.firstImageFeature) {
        result.type = 'boutique'
        result.imgWidth = 192
      } else if (template.usageImage === 1) {
        result.type = 'host'
        result.imgWidth = 256
      }
      return result
    },
    loadTemplates(contentTemplateList) {
      const results = new Array(contentTemplateList.length)
      let completed = 0
      contentTemplateList.forEach((template, index) => {
        const params = {
          orderByField: template.searchSortOrder,
          orderByType: template.searchSortOrderType,
          pageSize: 8,
          pageNum: 0
        }
        try {
          const searchField = JSON.parse(template.searchField)
          if (searchField) Object.assign(params, searchField)
        } catch (e) {}
        const imgAttr = this.getImgAttr(template)
        this.$axios({
          url: '/realNet/video/getVideoInfos',
          method: 'get',
          headers: { token: getToken() || '123456789' },
          params
        }).then(res => {
          const content = res.data.result ? res.data.result.content : null
          const info = {
            title: template.name,
            list: [],
            mainList: [],
            recommendList: [],
            searchField: template.searchField,
            isContent: true
          }
          if (content) {
            content.forEach((item, idx) => {
              let img = item.verticalImage
              if ((imgAttr.type === 'boutique' && idx === 0) || imgAttr.type === 'host') {
                img = item.horizontalImage
              }
              if (idx < 5) {
                info.mainList.push({
                  id: item.id,
                  img: img,
                  name: item.videoName,
                  intro: item.description,
                  grade: item.score
                })
              } else {
                info.recommendList.push({
                  id: item.id,
                  name: item.videoName
                })
              }
            })
            info.list = info.mainList
          }
          results[index] = info
          completed++
          if (completed === contentTemplateList.length) {
            this.templateData = results
          }
        })
      })
    },
    moreContentsClick(info) {
      this.$router.push({
        path: '/search',
        query: { searchField: info.searchField }
      })
    },
    movieClick(item) {
      if (this.detailPage === 'DownloadDetailPage') {
        this.$router.push({ path: '/download-detail', query: { id: item.id } })
      } else {
        this.$router.push({ path: '/tvplay-page', query: { id: item.id } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  overflow: hidden;
}

.home ::v-deep .btnOuter,
.home ::v-deep .dots {
  display: none;
}

.images {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  ::v-deep img {
    z-index: 1;
    width: 100%;
    position: relative;
    height: 576px !important;
  }

  ::v-deep #loopImages {
    height: 576px !important;
  }
}

.popular_box {
  width: 100%;
  height: 446px;
  background: linear-gradient(180deg, rgba(50, 40, 210, 0.3), rgba(209, 47, 60, 0));
  position: absolute;
  top: 576px;
  z-index: 3;
}

.advertisement {
  margin-top: 30px;
  img {
    width: 100%;
    border-radius: 5px;
  }
}
</style>
